import React from 'react';
import './forms.css';

const InvestorForm = () => {
    return (
        <div className="forms">
            <iframe
                src="https://docs.google.com/forms/d/e/1FAIpQLSesuDT7DEfunqqFWldksMIBT1lWXx5hNxd3zBeOGMh5M76sTA/viewform?embedded=true"
                width="100%" /* Set the iframe width to 100% */
                height="100%" /* Allow the height to adapt to the container */
                frameBorder="0"
                title="General Delegate Form"
            >
                Loading…
            </iframe>
        </div>
    );
}

export default InvestorForm;
